import { styled } from '@linaria/react';
import { TitleRow as BaseTitleRow } from '../../components/Section';
import { space } from '../../theme/tokens';

export const TitleRow = styled(BaseTitleRow)`
  && {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: ${space['space-300']};
  }
`;
